import {
  Button,
  ButtonVariants,
  Modal,
  ModalStage,
  Text,
  TrashIcon,
  useModalContext
} from 'stubben-edge-unified-frontend-react-components';
import { CAMPAIGN_DELETE_MODAL } from '@/constants/modals';

export interface DeleteModalProps {
  onConfirm: () => void;
  isPending?: boolean;
  campaignName?: string;
}

function DeleteModal({
  onConfirm,
  isPending = false,
  campaignName
}: DeleteModalProps) {
  const modal = useModalContext();

  const handleClose = () => {
    if (!isPending) {
      modal.close(CAMPAIGN_DELETE_MODAL);
    }
  };

  return (
    <Modal name={CAMPAIGN_DELETE_MODAL} testIdentifier="campaign-delete-modal">
      <ModalStage
        title="Delete campaign?"
        leftSlot={<TrashIcon size={32} className="text-error" />}
        testIdentifier="campaign-delete-modal-stage"
        handleClose={handleClose}
        actions={
          <div className="flex w-full items-center justify-end gap-4">
            <Button
              variant={ButtonVariants.Secondary}
              onClick={handleClose}
              disabled={isPending}
              testIdentifier="campaign-delete-modal-cancel"
            >
              Cancel
            </Button>
            <Button
              mode="error"
              onClick={onConfirm}
              loading={isPending}
              disabled={isPending}
              testIdentifier="campaign-delete-modal-confirm"
            >
              Delete
            </Button>
          </div>
        }
      >
        <Text variant="tertiary" size="md">
          Are you sure you want to delete
          {campaignName ? ` "${campaignName}"` : ' this campaign'}? This action
          cannot be undone.
        </Text>
      </ModalStage>
    </Modal>
  );
}

export default DeleteModal;
